import React, { FC } from "react";
import cx from "classnames";

import { LoadingIcon } from "~/ui-kit/icons/LoadingIcon";

import "./Button.scss";
import { ButtonVariant } from "./Button.types";

export type ButtonProps = {
  variant?: ButtonVariant;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  isLoading?: boolean;
};

export const Button: FC<ButtonProps> = ({
  onClick,
  variant = "primary",
  type = "button",
  disabled,
  className = "",
  children,
  isLoading,
}) => {
  return (
    <button
      className={cx(
        {
          disabled,
        },
        `button-base rounded-3 w-100 p-2 fs-sm fw-sd d-flex align-items-center justify-content-center text-center`,
        variant,
        className
      )}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {isLoading ? (
        <>
          <LoadingIcon size="20" />
          {children}
        </>
      ) : (
        <>{children}</>
      )}
    </button>
  );
};
